import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'
import { supabaseApi } from '~/supabase/api'

export const useDownloadFile = () => {
  return useMutation<Blob, Error, string>({
    mutationFn: async (filename: string) => {
      const { data, error } = await supabaseApi.storage.from('imports').download(filename)

      if (error) {
        toast.error(`Download failed ${error.message}`)
        throw error.message
      }

      return data
    },
  })
}
